package scenes

import com.soywiz.korinject.*
import scenes.levels.*
import scenes.test.*

fun AsyncInjector.configureTestScenes() {
    mapPrototype { MainTestScene() }
    mapPrototype { Box2dScene() }
    mapPrototype { GamePauseScene() }
    mapPrototype { MultiplayerRunScene() }
    mapPrototype { SinglePlayerScene() }
    mapPrototype { Bo2dSeparatedScene() }
}

fun AsyncInjector.configureGameScenes() {
    mapPrototype { MainMenuScene() }
    mapPrototype { LobbyScene() }
    mapPrototype { TalentsScene() }
    mapPrototype { TrainingScene() }

    mapPrototype { SceneLoadingScene() }

    // levels
    mapPrototype { Level1Scene() }
    mapPrototype { Level2Scene() }
    mapPrototype { Level3Scene() }
    mapPrototype { Level4Scene() }
    mapPrototype { Level5Scene() }
    mapPrototype { Level6Scene() }
}
